import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth/authRoles';

import KycPage from './KycPage';
import KycApprovedPage from './pages/KycApproved/KycApprovedPage';
import KycDeclinedPage from './pages/KycDeclined/KycDeclinedPage';
import KycInReviewRoute from './pages/KycInReview/KycInReviewRoute';
import KycManuallyInReviewPage from './pages/KycManuallyInReview/KycManuallyInReviewPage';
import KycNotStartedPage from './pages/KycNotStarted/KycNotStartedPage';
import KycPlaidPage from './pages/KycPlaid/KycPlaidPage';
import KycSourceOfFundsPage from './pages/KycSourceOfFunds/KycSourceOfFundsPage';
import KycStartedPage from './pages/KycStarted/KycStartedPage';
import KycSubmittedPage from './pages/KycSubmitted/KycSubmittedPage';

const KycRoute: FuseRouteItemType = {
  path: 'kyc',
  element: <KycPage />,
  auth: AUTH_ROLES.parent, // []
  children: [
    {
      path: 'approved',
      element: <KycApprovedPage />,
    },
    {
      path: 'declined',
      element: <KycDeclinedPage />,
    },

    {
      path: 'manually-review',
      element: <KycManuallyInReviewPage />,
    },
    {
      path: 'source-of-funds',
      element: <KycSourceOfFundsPage />,
    },
    {
      path: 'not-started-address',
      element: <KycNotStartedPage />,
    },
    {
      path: 'started',
      element: <KycStartedPage />,
    },
    {
      path: 'submitted',
      element: <KycSubmittedPage />,
    },
    {
      path: 'plaid',
      element: <KycPlaidPage />,
    },
    {...KycInReviewRoute},
  ],
};

export default KycRoute;
